import axios from "axios";
import {getConfig} from '../helpers/config';

export class FaseService {

	baseAPIUrl = `${getConfig()?.url}fasi`;

	getById = async (id) => {
		return await axios.get(`${this.baseAPIUrl}/${id}`)
											.then(res => res.data);
	}

	getAllDt = async (data) => {
		return await axios.post(`${this.baseAPIUrl}/dt`, data)
											.then(res => res.data);
	}

	create = async (data) => {
		return await axios.post(`${this.baseAPIUrl}/`, data)
											.then(res => res.data);
	}

	update = async (data) => {
		return await axios.put(`${this.baseAPIUrl}/`, data)
											.then(res => res.data);
	}

	delete = async (id) => {
		return await axios.delete(`${this.baseAPIUrl}/${id}`)
											.then(res => res.data);
	}

	getFaseByTipologiaAndPresentazioneDomandaId = async (type, presentazioneDomandeId) => {
		return await axios.get(`${this.baseAPIUrl}/type/${type}/presentazione/${presentazioneDomandeId}`)
											.then(res => res.data);
	}

	getAll = async () => {
		return await axios.get(`${this.baseAPIUrl}/`).then(res => res.data);
	}

	getAllByBandoId = async (bandoId) => {
		return await axios.get(`${this.baseAPIUrl}/bando/${bandoId}`).then(res => res.data);
	}
}
